export default __webpack_public_path__ + "af833d360f181b0ebe9df815456ac0c6.png";